export default "__VITE_ASSET__CQIm9e$M__"